export enum Pronouns {
  HE_HIM = 'He/Him',
  SHE_HER = 'She/Her',
  THEY_THEM = 'They/Them',
  NONE = 'None',
  OTHER = 'Other',
}
